import React from "react";
import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TouchableOpacity,
} from "react-native";
import { Feather } from "@expo/vector-icons";

type SendDiagnosticsButtonProps = {
  onPress: () => void;
  isSending: boolean;
};

function SendDiagnosticsButton({
  onPress,
  isSending,
}: SendDiagnosticsButtonProps): React.JSX.Element {
  return (
    <TouchableOpacity
      style={styles.button}
      onPress={onPress}
      disabled={isSending}
    >
      {isSending ? (
        <ActivityIndicator color="#fff" size="small" />
      ) : (
        <>
          <Feather name="send" size={18} color="#fff" style={styles.icon} />
          <Text style={styles.buttonText}>Send Diagnostics</Text>
        </>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: "#007AFF",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 12,
    borderRadius: 8,
  },
  icon: {
    marginRight: 8,
  },
  buttonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
  },
});

export default SendDiagnosticsButton;
